import { render } from "./Footer.vue?vue&type=template&id=73ba8b36&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=73ba8b36&lang=scss&scoped=true"

import exportComponent from "/home/marko/Documents/Projects/praksa/petikom-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ba8b36"]])

export default __exports__